const HORIZONTAL_CARD_EVENT_CLICK = "click-horizontal-card";

// eslint-disable-next-line import/prefer-default-export
export { HORIZONTAL_CARD_EVENT_CLICK };
